function isNetworkAuthError(error) {
  if (!error) {
    return false;
  }

  const message = (error.message || "").toLowerCase();
  const status = error.status ?? error.code;

  if (error.name === "AuthRetryableFetchError") {
    return true;
  }

  if (status === 0 || status === "0") {
    return true;
  }

  return (
    message.includes("fetch") ||
    message.includes("network") ||
    message.includes("failed to fetch") ||
    message.includes("networkerror")
  );
}

function isInvalidCredentialsError(error) {
  if (!error) {
    return false;
  }

  const message = (error.message || "").toLowerCase();
  return (
    message.includes("invalid login credentials") ||
    message.includes("invalid email or password") ||
    message.includes("invalid credentials")
  );
}

/**
 * Maps Supabase auth errors to clearer onboarding copy.
 */
export function formatSignInError(error) {
  if (!error) {
    return null;
  }

  if (isNetworkAuthError(error)) {
    return "Connection is weak. Check your network or continue with a saved session if available.";
  }

  if (isInvalidCredentialsError(error)) {
    return "Email or password is incorrect.";
  }

  return error.message || "Unable to sign in. Please try again.";
}

export function formatPasswordResetError(error) {
  if (!error) {
    return null;
  }

  if (isNetworkAuthError(error)) {
    return "Connection is weak. Check your network and try again.";
  }

  return error.message || "Failed to send reset email.";
}
